import { Form, Button } from "react-bootstrap";
import arrayUtilities from "../../../utilities/arrayUtilities";
import Loading from "../loading";

export const MoveData = ({ formData, projects, selectedProject, onProjectChange, jobs, selectedJob, setSelectedJob, workflows, selectedWorkflow, setSelectedWorkflow, featureTypes, featureFormDataFields, setFeatureFormDataValues, selectedFeatureType, setSelectedFeatureType, isLoadingJobs, isLoadingWorkflows, onClickAddJob, isLoading }) => {
    const fetchItemInputType = (item) => {
        switch (item.type) {
            case "DropDownList":
                return (
                    <Form.Select onChange={ e => setFeatureFormDataValues(prevState => ({ ...prevState, [`${ item.name }`]: e.target.value })) } value={ formData[item.name] ?? "" } size="sm">
                        <option value="">Select a value</option>{ item.values && item.values.length > 0 && item.values.map(value => <option selected={ value === formData[item.name] } key={ value } value={ value }>{ value }</option>) }</Form.Select>
                )
            case "Radio":
                return (
                    <div className="d-flex flex-column">{ item.values && item.values.length > 0 && item.values.map(value => (
                        <Form.Check checked={ value === formData[item.name] } key={ `radio-check-${ value }` } value={ value } onChange={ e => setFeatureFormDataValues(prevState => ({ ...prevState, [`${ item.name }`]: e.target.value })) } type="radio" id={ `radio-check-${ value }` } name="radio-input" label={ value } />
                    )) }
                    </div>
                )
            default:
                return <Form.Control size='sm' type="text" value={ formData[item.name] ?? "" } onChange={ e => setFeatureFormDataValues(prevState => ({ ...prevState, [`${ item.name }`]: e.target.value })) } />
        }
    }

    return (
        <>
            {
                isLoading
                    ? <Loading />
                    : <>
                        <Form.Group className='mb-3 row'>
                            <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="project">
                                Project
                            </Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                <Form.Select id="project" size='sm' value={ selectedProject } onChange={ e => onProjectChange(e.target.value) }>
                                    <option value="">Select a Project</option>
                                    {
                                        !arrayUtilities.isNullOrEmpty(projects) && projects
                                            .map((project, index) => <option key={ index } value={ project.id }>{ project.name }</option>)
                                    }
                                </Form.Select>
                            </div>
                        </Form.Group>

                        <Form.Group className='mb-3 row'>
                            <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="job">
                                Job
                            </Form.Label>
                            <div className="col-md-9 gap-2 d-flex align-items-center">
                                {
                                    isLoadingJobs
                                        ? <Loading />
                                        : <>
                                            <Form.Select id="job" size='sm' value={ selectedJob } onChange={ e => setSelectedJob(e.target.value) }>
                                                <option value="">Select a Job</option>
                                                {
                                                    !arrayUtilities.isNullOrEmpty(jobs) && jobs
                                                        .map((job, index) => <option key={ index } value={ job.id }>{ job.name }</option>)
                                                }
                                            </Form.Select>
                                            <Button onClick={ onClickAddJob } size="sm" variant="primary" className="align-self-stretch fi-plus my-1" />
                                        </>
                                }
                            </div>
                        </Form.Group>

                        <Form.Group className='mb-3 row'>
                            <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="workflow">
                                Workflow
                            </Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                {
                                    isLoadingWorkflows
                                        ? <Loading />
                                        : <Form.Select id="workflow" size='sm' value={ selectedWorkflow } onChange={ e => setSelectedWorkflow(e.target.value) }>
                                            <option value="">Select a Workflow</option>
                                            {
                                                !arrayUtilities.isNullOrEmpty(workflows) && workflows
                                                    .map((workflow, index) => <option key={ index } value={ workflow.id }>{ workflow.name }</option>)
                                            }
                                        </Form.Select>
                                }
                            </div>
                        </Form.Group>
                        {
                            featureTypes &&
                            <Form.Group className='mb-3 row'>
                                <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="workflow-template">
                                    Type
                                </Form.Label>
                                <div className="col-md-9 d-flex align-items-center">

                                    {
                                        isLoadingJobs || isLoadingWorkflows
                                            ? <Loading />
                                            : <Form.Select size='sm' value={ selectedFeatureType } onChange={ (e) => setSelectedFeatureType(e.target.value) }>
                                                <option value="">Select a Type</option>
                                                {
                                                    featureTypes && featureTypes
                                                        .map((item, index) => <option key={ index } value={ item.name }>{ item.name }</option>)
                                                }
                                            </Form.Select>
                                    }
                                </div>
                            </Form.Group>
                        }
                        {
                            featureTypes && featureTypes.length > 0 && featureFormDataFields && featureFormDataFields.map((item, index) => {

                                return (
                                    <Form.Group key={ index } className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="workflow-template">
                                            { item.name }
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            { fetchItemInputType(item) }
                                        </div>
                                    </Form.Group>
                                )
                            })
                        }
                    </>
            }
        </>
    )
}